import React from 'react'
import SchedulesHomeNavigation from './SchedulesHomeNavigation'
import TeamSchedule from '../../schedule/TeamSchedule'

const TeamSchedulesHome = () => {
	return (
		<div style={{ overflowX: 'hidden' }}>
			<SchedulesHomeNavigation />
			<TeamSchedule />
		</div>
	)
}

export default TeamSchedulesHome
